export default __webpack_public_path__ + "static/code-ka-cbf81fa02560a3a7b6f744412ddc435c.jpg";